module.exports = __webpack_public_path__ + "img/qrcode_wb.9c87d459.jpg";